<mat-card appearance="outlined" *ngIf="settings_model.credit_reporting.credit_reporting_enabled_scheme_wise">
    <mat-card-title>Credit Reporting</mat-card-title>
    <div>
        <mat-card-subtitle class="alert alert-info" *ngIf="previous_credit_reporting">Credit Reporting is currently enabled.</mat-card-subtitle>
        <mat-card-subtitle>SimpleBills can help you build credit by reporting your payment history to Equifax.</mat-card-subtitle>
    </div>
    <mat-card-content>
        <app-credit-reporting-form [credit_reporting_model]="settings_model" (modelChanged)="onModelChanged($event)" (formValid)="onFormValid($event)"></app-credit-reporting-form>
    </mat-card-content>
    <mat-card-actions>
        <div *ngIf="!settings_model.credit_reporting.credit_reporting_enabled" class="alternate-recipient-checkbox">
            <input type="checkbox" [checked]="credit_reporting_confirmation" (change)="creditReportingCheck()">
            <span>
                I acknowledge that if I turn off Credit Reporting, my current rate will not be preserved and re-enrollment may be subject to any future fee increases.
            </span>
        </div>
        <button mat-raised-button (click)="onSave()" color="primary" style="width:250px" [disabled]="saveButtonCheck()">
            Save
        </button>
        <div class="mt-2 result-container"><nexus-form-result [model]="credit_reporting_result_model"></nexus-form-result></div>
    </mat-card-actions>
</mat-card>